import { UserRole, Route, RolePermissions } from '@/types/roles';

export const routesByRole: Record<UserRole, Route[]> = {
  [UserRole.ADMIN]: [
    { path: '/dashboard', name: 'Dashboard', icon: 'LayoutDashboard' },
    { path: '/clientes', name: 'Clientes', icon: 'Users' },
    { path: '/usuarios', name: 'Usuarios', icon: 'UserCog' },
    // Secciones ocultas temporalmente:
    // { path: '/costos', name: 'Costos', icon: 'DollarSign' },
    // { path: '/bots', name: 'Bots', icon: 'Bot' },
    // { path: '/reportes', name: 'Reportes', icon: 'FileText' },
    // { path: '/configuracion', name: 'Configuración', icon: 'Settings' }
  ],
  [UserRole.DEVELOPER]: [
    { path: '/dashboard', name: 'Dashboard', icon: 'LayoutDashboard' },
    { path: '/clientes', name: 'Clientes', icon: 'Users' },
    { path: '/bots', name: 'Bots', icon: 'Bot' },
    { path: '/costos', name: 'Costos', icon: 'DollarSign' },
    { path: '/configuracion', name: 'Configuración', icon: 'Settings' }
  ],
  [UserRole.CLIENT]: [
    { path: '/dashboard', name: 'Dashboard', icon: 'LayoutDashboard' },
    { path: '/leads', name: 'Leads', icon: 'Users' },
    { path: '/traces', name: 'Llamadas', icon: 'Phone' },
    { path: '/assistant', name: 'Mi Asistente', icon: 'Bot' },
    { path: '/profile', name: 'Mi Perfil', icon: 'User' }
  ]
};

export const rolePermissions: Record<UserRole, RolePermissions> = {
  [UserRole.ADMIN]: {
    canViewClients: true,
    canViewAllBots: true,
    canViewUsers: true,
    canViewDetailedCosts: true,
    canViewInfrastructure: true
  },
  [UserRole.DEVELOPER]: {
    canViewClients: true,
    canViewAllBots: true,
    canViewUsers: false,
    canViewDetailedCosts: true,
    canViewInfrastructure: true
  },
  [UserRole.CLIENT]: {
    canViewClients: true,
    canViewAllBots: false,
    canViewUsers: false,
    canViewDetailedCosts: false,
    canViewInfrastructure: false
  }
};